import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { GrupoLocalNivel1 } from '../../app/pages/domain/domain.model';
import { AccountService } from './account.service';
import { CommandResult } from '../pages/domain/commandResult';


@Injectable({ providedIn: 'root' })
export class GrupoLocalNivelService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    post(grupoLocalNivel1: any) {
        return this.http.post(`${SCAMP_API.accountApiV1}/grupolocalnivel1`, grupoLocalNivel1,
            { headers: this.account.composeHeaders() });
    }

    // Grupo local
    getAllGrupoLocalNivel1(): Observable<GrupoLocalNivel1[]> {
        return this.http.get<GrupoLocalNivel1[]>(`${SCAMP_API.accountApiV1}/gruposlocalnivel1`,
            { headers: this.account.composeHeaders() });
    }

    getById(id: number):Observable<GrupoLocalNivel1> {
        return this.http.get<GrupoLocalNivel1>(`${SCAMP_API.accountApiV1}/gruposlocalnivel1/${id}`,
            { headers: this.account.composeHeaders() });
    }


    delete(grupoLocalNivel1Id: number): Observable<CommandResult> {
        return this.http.delete<CommandResult>(`${SCAMP_API.accountApiV1}/grupolocalnivel1-delete/${grupoLocalNivel1Id}`,
            { headers: this.account.composeHeaders() });
    }


}